module.exports = __webpack_public_path__ + "static/media/notifications-activer-cercle.15e7d9bc.png";